import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useParams, generatePath } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const Benefit = (props) => {
  const { id, siteId, mallId } = useParams();
  const { user } = props;
  const [benefitData, setBenefitData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const history = useHistory();
  const [shopGroupON, setShopGroupONValues] = useState([]);
  const [shopGroupOFF, setShopGroupOFFValues] = useState([]);
  const [shopGroupMaster, setShopGroupMaster] = useState([]);

  const [rankValues, setRankValues] = useState({
    rank_id: id,
    rank_name: "",
    point_give: 0,
    point_lower: 0,
    point_upper: 0,
  });

  const [benefitValues, setBenefitValues] = useState({
    rank_id: id,
    benefit_image_url: '',
    benefit_id: "",
    benefit_title: "",
    benefit_summary: "",
    benefit_detail: "",
    expiry: "",
    receiving_type: constClass.RECEIVING_TYPE.TICKET_DELIVERY,
    uploadfile: null,
    uploadfiletype: null,
    deletefile: null,
    upd_date: "",
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    try {
      // 先にAPI実行
      const benefit = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/benefit/${siteId}/${id}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;

      //ランクマスタ情報を取得
      const rank_info = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/ranklist/`, { site_id: siteId }, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data;
      const rank = rank_info.find(x => x.rank_id === Number(id));

      setBenefitData(benefit);
      setRankValues({
        rank_id: rank.rank_id || id,
        rank_name: rank.rank_name ? rank.rank_name : "",
        point_give: rank.point_give ? rank.point_give : 0,
        point_lower: rank.point_lower ? rank.point_lower : 0,
        point_upper: rank.point_upper ? rank.point_upper : 0
      });
      const shopGroup = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/shopgroup/${siteId}/${mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      })).data.map((val) => { return { value: val.shop_group_id, label: val.shop_group_name }; });
      setShopGroupMaster(shopGroup);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, id, mallId]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setBenefitValues({ ...benefitValues, [name]: value });
  }

  const handleBackClick = () => {
    history.push(`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })}customerrank`);
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.expiry) {
      window.alert('有効期限日を入力してください。');
      return;
    }
    var params = data;

    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    params.expiry = data.expiry ? moment(params.expiry).format('YYYYMMDD') : "";
    if (data.uploadfiletype === null) data.uploadfile = null;
    params.shop_group = null;

    if (params.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR && shopGroupON.length > 0) {
      params.shop_group = shopGroupON.map(shop => ({ site_id: siteId, shop_group_id: shop.value, use_flg: constClass.FLAG.ON }));
    } else if (params.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR && shopGroupOFF.length > 0) {
      params.shop_group = shopGroupOFF.map(shop => ({ site_id: siteId, shop_group_id: shop.value, use_flg: constClass.FLAG.OFF }));
    }

    let res;
    try {
      setLockData(true);
      if (benefitValues.benefit_id) {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/benefit/${benefitValues.benefit_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
        handleResetClick();
      }
      setLockData(false);
    }
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setBenefitValues({
      rank_id: id,
      benefit_id: "",
      benefit_title: "",
      benefit_summary: "",
      benefit_detail: "",
      uploadfile: "",
      uploadfiletype: "",
      expiry: "",
      receiving_type: constClass.RECEIVING_TYPE.TICKET_DELIVERY,
      benefit_image_url: "",
      upd_date: "",
    });
    setShopGroupONValues([]);
    setShopGroupOFFValues([]);
  }


  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`ランク特典[${data.benefit_id}:${data.benefit_title}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      benefit_id: data.benefit_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const handleChangeShopGroupOFF = (data) => {
    setShopGroupOFFValues(data);
  }

  const handleChangeShopGroupON = (data) => {
    setShopGroupONValues(data);
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.benefit_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const renderRegisterButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        新規登録
      </button>
    )
  }

  const handleChangeFile = (e) => {
    const value = e.target.files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      setBenefitValues({
        ...benefitValues,
        uploadfile: reader.result,
        uploadfiletype: value.type,
        deletefile: benefitValues.benefit_image_url
      });
    }
    reader.readAsDataURL(value);
  }

  /* 編集ボタン押下 */
  const handleUpdateClick = async (data) => {
    var temp = data;
    temp.deletefile = null;
    temp.uploadfiletype = null;
    if (data.benefit_image_url != null) temp.uploadfile = `/${siteId}/${constClass.BENEFIT_IMAGE_DIR + data.benefit_image_url}`;
    else temp.uploadfile = null;
    const shopGroupONValues = data.m_benefit_shop_group
      .filter(a => a.use_flg === constClass.FLAG.ON)
      .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }));

    const shopGroupOFFValues = data.m_benefit_shop_group
      .filter(a => a.use_flg === constClass.FLAG.OFF)
      .map(a => ({ value: a.shop_group_id, label: shopGroupMaster.find(x => x.value === a.shop_group_id).label }));

    if (shopGroupONValues.length > 0) {
      setShopGroupONValues(shopGroupONValues);
    } else if (shopGroupOFFValues.length > 0) {
      setShopGroupOFFValues(shopGroupOFFValues);
    }
    setBenefitValues(temp);
  }

  const handleDeleteFile = () => {
    setBenefitValues({ ...benefitValues, uploadfile: null, uploadfiletype: null, deletefile: benefitValues.benefit_image_url });
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.benefit_title === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="row mx-0 my-2 px-1-env">
          <div className="row col-12 mt-2 mb-2">
            <div className='col-2'>
              <button type="button"
                className={`btn btn-secondary mx-1 w-100 text-nowrap`}
                onClick={() => { handleBackClick() }}>
                戻る
              </button>
            </div>
          </div>
        </div>
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bordered table-striped">
              <thead className={`table-info`}>
                <tr>
                  <td className="text-center align-middle">
                    ランクID
                  </td>
                  <td className="text-center align-middle">
                    ランク名称
                  </td>
                  <td className="text-center align-middle">
                    ボーナスポイント
                  </td>
                  <td className="text-center align-middle">
                    獲得ポイント（下限）
                  </td>
                  <td className="text-center align-middle">
                    獲得ポイント（上限）
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {/* ランクID */}
                  <td className="text-center align-middle">
                    {rankValues.rank_id}
                  </td>
                  {/* ランク名称 */}
                  <td className="text-center align-middle">
                    {rankValues.rank_name}
                  </td>
                  {/* ボーナスポイント */}
                  <td className="text-center align-middle">
                    {rankValues.point_give}
                  </td>
                  {/* 獲得ポイント（下限） */}
                  <td className="text-center align-middle">
                    {rankValues.point_lower}
                  </td>
                  {/* 獲得ポイント（上限） */}
                  <td className="text-center align-middle">
                    {rankValues.point_upper}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bordered table-striped">
              <thead className={`table-info`}>
                <tr>
                  <td className="text-center align-middle">
                    特典ID
                  </td>
                  <td className="text-center align-middle">
                    特典タイトル
                  </td>
                  <td className="text-center align-middle">
                    処理
                  </td>
                </tr>
              </thead>
              <tbody>
                {benefitData && benefitData.length > 0 && benefitData.map((data, idx) => (
                  <tr key={idx}>
                    {/* 特典ID */}
                    <td className="text-center align-middle">
                      {data.benefit_id}
                    </td>
                    {/* 特典タイトル */}
                    <td className="text-center align-middle">
                      {data.benefit_title}
                    </td>
                    {/* 処理 */}
                    <td className="text-center align-middle text-nowrap">
                      {renderUpdateButton(data)}
                    </td>
                  </tr>
                ))
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="mx-1">
          <div className="row mb-3">
            <div className="col-2 text-center">
              {renderRegisterButton(benefitValues)}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <span>特典ID</span>
            </div>
            <div className="col-2 text-center align-self-center">
              <input type="text" className="form-control" name="benefit_id" defaultValue={benefitValues.benefit_id} placeholder="新規" readOnly />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <span>特典タイトル</span>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="text" className="form-control" name="benefit_title" value={benefitValues.benefit_title} onChange={handleChange} placeholder="特典タイトルを入力してください" />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_summary">特典概要</label>
            </div>
            <div className="col-5 align-self-center">
              <input type="text" className="form-control" name="benefit_summary" id="benefit_summary" value={benefitValues.benefit_summary} placeholder="特典の概要を入力してください" onChange={handleChange}></input>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_detail">特典詳細</label>
            </div>
            <div className="col-5 align-self-center">
              <textarea className="form-control" rows="3" name="benefit_detail" id="benefit_detail" value={benefitValues.benefit_detail} onChange={handleChange}></textarea>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="benefit_image">特典画像</label>
            </div>
            <div className="col-5 align-self-center">
              {!(benefitValues.uploadfile) && <input type="file" className="form-control-file" name="benefitImage" id="benefitImage" value="" onChange={handleChangeFile} onClick={e => (e.target.value = null)} />}
              {benefitValues.uploadfile && <object id="uploadfileview" className="w-100" data={benefitValues.uploadfile} type={benefitValues.uploadfiletype}><img className="w-100" src={benefitValues.uploadfile} alt='uploadfile' /></object>}
              {benefitValues.uploadfile && <input type="button" className="form-controll" name="deletefile" id="deletefile" onClick={handleDeleteFile} value="ファイル削除" />}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="expiry">有効期限日</label>
            </div>
            <div className="col-4 pt-1 text-center">
              <input type="text" className="form-control" name="expiry" value={benefitValues.expiry ? benefitValues.expiry.replace(/-/g, "") : ""} onChange={handleChange} placeholder="YYYYMMDD" />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="receiving_type">受け取り区分</label>
            </div>
            <div className="col-3">
              <select className="form-control" id="receiving_type" name="receiving_type" value={benefitValues.receiving_type} onChange={handleChange}>
                <option key={constClass.RECEIVING_TYPE_NAME.TICKET_DELIVERY} value={constClass.RECEIVING_TYPE.TICKET_DELIVERY}>{constClass.RECEIVING_TYPE_NAME.TICKET_DELIVERY}</option>
                <option key={constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_QR} value={constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR}>{constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_QR}</option>
                <option key={constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_BUTTON} value={constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON}>{constClass.RECEIVING_TYPE_NAME.DIGITAL_TICKET_BUTTON}</option>
              </select>
            </div>
          </div>
          {benefitValues.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR && (
            <React.Fragment>
              {shopGroupON.length === 0 && (
                <div className="row mb-3">
                  <div className="col-2 text-center align-self-center">
                    <label htmlFor="use_flg">利用不可店舗グループ</label>
                  </div>
                  <div className="col-5 align-self-center">
                    <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={shopGroupOFF} onChange={handleChangeShopGroupOFF} placeholder="クーポンを利用できない店舗グループ" />
                  </div>
                </div>
              )}
              {shopGroupOFF.length === 0 && (
                <div className="row mb-3">
                  <div className="col-2 text-center align-self-center">
                    <label htmlFor="use_flg">利用可能店舗グループ</label>
                  </div>
                  <div className="col-5 text-center align-self-center">
                    <Select options={shopGroupMaster} isMulti closeMenuOnSelect={false} value={shopGroupON} onChange={handleChangeShopGroupON} placeholder="クーポンを利用できる店舗グループ" />
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
          <div className="row mb-2 pb-4">
            <div className="col-3 text-center">
              {renderRegistButton(benefitValues)}
            </div>
            <div className="col-3 text-center">
              {renderDeleteButton(benefitValues)}
            </div>
            <div className="col-3 text-center">
              {renderResetButton(benefitValues)}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Benefit;